import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccessDeveloperConsole } from "../utils/developerConsoleAccess";

type Props = { children: React.ReactNode };

/**
 * Developer Console: requires a valid session token and a role allowed to open the console.
 * Unauthenticated users are sent to login with return path for seamless SSO-style return.
 */
const DeveloperConsoleGate: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("accessToken") : null;

  if (!token) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  if (!user || !canAccessDeveloperConsole(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default DeveloperConsoleGate;
